/**
 * External Imports
 */
import { NeuCard } from '@neutron/react';

/**
 * Style Imports
 */
import styled from 'styled-components';

export const UnlistedPatientRoundCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  width: 26em;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-top: var(--card-spacing);
  padding-right: var(--card-spacing);
  padding-bottom: var(--card-spacing);
  padding-left: var(--card-spacing);
  height: 56px;
  width: 100%;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const ModalTitle = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;

export const ModalFooter = styled(NeuCard)`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  padding-top: var(--card-spacing) !important;
`;
